export const CAMPAIGN_PIPELINE_KEYS = {
  all: ["campaignPipeline"] as const,
  definitions: () => [...CAMPAIGN_PIPELINE_KEYS.all, "definitions"] as const,
  lists: () => [...CAMPAIGN_PIPELINE_KEYS.all, "list"] as const,
  list: (campaignId: string, stage?: string) =>
    [...CAMPAIGN_PIPELINE_KEYS.lists(), campaignId, stage ?? "all"] as const,
  details: () => [...CAMPAIGN_PIPELINE_KEYS.all, "detail"] as const,
  detail: (campaignId: string, influencerId: string) =>
    [...CAMPAIGN_PIPELINE_KEYS.details(), campaignId, influencerId] as const,
};
